<template>
  <div>
    <div id="top" class="gr-section-wrapper gr-section-wrapper-lg-row gr-sm-scrollable" :style="paddingTop">
      <div class="gr-content-container gr-scrollable" :style="sectionHeight">
        <div class="gr-text-container gr-text-container-lg-column px-lg-5" :style="paddingY">
          <h1 class="px-4 gr-header-2">{{ name }}</h1>
          <div class="gr-gallery-container px-4">
            <VueGallery :images="images" :index="index" @close="index = null"></VueGallery>
            <div
              class="image"
              :key="imageIndex"
              v-for="(image, imageIndex) in images"
              @click="index = imageIndex"
              role="img"
              :aria-label="image.description && image.description.trim() ? image.description : ('Handgefertigter ' + name + ' – Goldschmiede Goldregen München')"
              :style="{ backgroundImage: `url(${image.href})`, width: '300px', height: '200px', cursor: 'pointer' }"
              :on="imageDownloadFinished(1)"
            ></div>
          </div>
          <gr-btn-lite class="px-4" text="zurück" backgroundColor="turquise" @click.native="$routeBack()"></gr-btn-lite>
          <nav class="gr-cross-links px-4" aria-label="Weitere Kategorien">
            <h2 class="gr-cross-links-title">Weitere Kategorien</h2>
            <div class="gr-cross-links-list">
              <router-link v-if="name !== 'Ringe'" to="/schmuckstuecke/ringe">Ringe</router-link>
              <router-link v-if="name !== 'Ohrringe'" to="/schmuckstuecke/ohrringe">Ohrringe</router-link>
              <router-link v-if="name !== 'Ketten'" to="/schmuckstuecke/ketten">Ketten</router-link>
              <router-link v-if="name !== 'Armschmuck'" to="/schmuckstuecke/armschmuck">Armschmuck</router-link>
              <router-link v-if="name !== 'Manschettenknöpfe'" to="/schmuckstuecke/manschettenknoepfe">Manschettenknöpfe</router-link>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <AppFooter backgroundColor="turquise"></AppFooter>
  </div>
</template>
<script>

import AppFooter from './../../layout/Footer'
import VueGallery from 'vue-gallery'
import grBtnLite from '@/components/grBtnLite'

export default {
  name: 'gallerie',
  props: {
    name: { type: String },
    imgObject: { type: Array }
  },
  components: {
    AppFooter,
    grBtnLite,
    VueGallery
  },
  data () {
    return {
      images: this.imgObject,
      index: null,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  beforeDestroy () {
    this.$store.commit('setHeader', true)
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.isNewLoading = true
    this.setLoading(true)
  },
  mounted () {
    this.handleResize()
  },
  beforeMount () {
    this.isNewLoading = false
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  computed: {
    paddingTop () {
      if (this.isDesktop) {
        return { padding: '50px 0 0 0 !important' }
      } else {
        return { padding: Math.round(this.$store.getters['dom/navBarHeight'] - 3) + 'px 0 30px 0 !important' }
      }
    },
    paddingY () {
      return this.isDesktop && {
        'padding-top': '45px !important',
        'padding-bottom': '45px !important'
      }
    },
    isDesktop: function () {
      return this.$store.getters['dom/isDesktop']
    },
    isNewLoadingFinished: function () {
      return !this.isNewLoading
    },
    isLoading: function () {
      return !this.$store.getters['loading/isLoadingApp']
    },
    isFullLoaded: function () {
      return this.isFullPageJsLoaded
    },
    sectionHeight () {
      return this.isDesktop && { 'min-height': Math.round(this.window.height - Math.min(65, this.$store.getters['dom/navBarHeight'])) + 'px !important' }
    }
  },
  methods: {
    imageDownloadFinished (id) {
      this.isImageLoading1 = false
      setTimeout(() => {
        this.setLoading(false)
      }, 50)
    },
    setLoading (isLoaded) {
      if ((this.isImageLoading1 && this.isNewLoading) ||
        (!this.isImageLoading1 && !this.isNewLoading)) {
        this.$store.commit('loading/SET_LOADING_APP', isLoaded)
      }
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    afterLoad: function () {
      this.isFullPageJsLoaded = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 0;
    margin: 5px;
    max-width: calc(min(50vw, 125px));
    max-height: calc(min(50vw, 125px));
    transition: all .35s cubic-bezier(.25, .46, .45, .94);
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  .image:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
  .blueimp-gallery>.next, .blueimp-gallery>.prev {
    border: 0 !important;
  }
  .gr-gallery-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 40px 0;
  }
  .gr-section-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100vh;
    padding-bottom: 10px;
    background-color: $color-gr-turquoise;
  }
  .gr-text-container {
    line-height: 1.1;
  }

  @media(min-width: 370px) {
    .image {
      max-width: calc(min(50vw, 150px));
      max-height: calc(min(50vw, 150px));
    }
  }
  .gr-cross-links {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
  .gr-cross-links-title {
    font-family: $font-content;
    font-size: 0.9em;
    font-weight: 500;
    letter-spacing: 0.05em;
    margin-bottom: 10px;
  }
  .gr-cross-links-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .gr-cross-links-list a {
    font-size: 0.85em;
    padding: 4px 12px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    text-decoration: none;
    color: inherit;
    transition: background-color 0.2s;
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
  @media(min-width: 760px) {
    .gr-text-container-lg-column {
      // prevent that on transition potential image below text-container moves
      min-height: 25vh;
    }
  }
  @media(min-width: $window-lg) {
    .gr-section-wrapper-lg-row {
      flex-direction: row;
      justify-content: flex-start;
    }
  }
</style>
